const notificationConfig = window?.["notificationConfig"];
export const notificationsDataUrl = notificationConfig?.notificationsApi ?? "";
export const notificationsSettingsDataUrl =
  notificationConfig?.notificationsSettingsApi ?? "";
export const notificationsSettingsSwitchDataUrl =
  notificationConfig?.notificationsSettingsSwitchApi ?? "";
export const notificationsSettingsAccountDataUrl =
  notificationConfig?.notificationsSettingsAccountApi ?? "";
export const notificationsFlyoutDataUrl =
  notificationConfig?.notificationsFlyoutApi ?? "";
